import { Chip } from "@mui/material";
import { chipStyles } from "styles/chip-styles";

interface LanguageChipWithColorProps {
  status: string;
}

export default function LanguageChipWithColor({
  status,
}: LanguageChipWithColorProps): JSX.Element {
  const styles = chipStyles({ value: status });

  return (
    <Chip size="small" variant="outlined" sx={styles.sx} label={styles.label} />
  );
}
